<div class="flex min-h-screen flex-col bg-gray-100">
	<header class="sticky top-0 z-50 bg-white shadow-md">
		<app-support-header></app-support-header>
	</header>

	<div class="flex flex-1 items-start justify-center p-2 md:p-4">
		<main class="w-full max-w-5xl">
			<router-outlet></router-outlet>
		</main>
	</div>

	<footer>
		<app-footer></app-footer>
	</footer>
</div>
